import { servedFilter, formatUtcForPocketBase, SERVED_CONTRACT, SERVED_CLAUSES, utcFreshnessClause } from '../contracts/servedRecommendation.v1.js'
import { classicResearchFilter } from './classicResearch.js'
import { planIdentity } from './planDrafts.js'
import { parseScrapedAt } from './servedTime.js'
const timestamp = value => /(?:Z|[+-]\d\d:\d\d)$/.test(String(value || '')) ? parseScrapedAt(value)?.getTime() : undefined

export function savedPlanFilter(draft, now = new Date(), recommendation = false) {
  const id = planIdentity(draft?.identity, draft?.identity?.kind)
  if (!id) throw new Error('Invalid saved listing identity')
  const scope = recommendation ? servedFilter('recommendation', now) : ['classic', 'specialist'].includes(id.kind) ? classicResearchFilter({ make: id.make, model: id.model,
    minYear: id.year, maxYear: id.year, country: id.country_code }, now) : [
      SERVED_CLAUSES.positivePrice, SERVED_CLAUSES.noPriceAnomaly, SERVED_CLAUSES.releaseActive,
      ...SERVED_CLAUSES.queryLineage.discovery, SERVED_CLAUSES.notGone, "source_flag != 'sold'", utcFreshnessClause('7d', now),
    ].join(' && ')
  return `${scope} && listing_id = ${id.listing_id} && country_code = '${id.country_code}'` +
    ` && make = ${JSON.stringify(id.make)} && model = ${JSON.stringify(id.model)} && year = ${id.year}` +
    ` && scraped_at <= '${formatUtcForPocketBase(now)}'` +
    (recommendation ? ` && source_checked_at <= '${formatUtcForPocketBase(now)}'` : '')
}

export function savedPlanLiveUntil(car, kind) {
  const observed = timestamp(car?.scraped_at)
  if (!Number.isFinite(observed)) return 0
  return observed + 7 * 86400000
}

export function savedPlanRecommendationUntil(car) {
  const source = timestamp(car?.source_checked_at)
  return Number.isFinite(source) ? Math.min(savedPlanLiveUntil(car),
    source + SERVED_CONTRACT.recommendation_surface.source_check_max_age_hours * 3600000) : 0
}

export function exactSavedPlanRow(draft, response, now = new Date()) {
  if (!Array.isArray(response.items) || !Number.isInteger(response.totalItems) || response.totalItems !== response.items.length || response.totalItems > 1) throw new Error('Ambiguous or incomplete current listing response')
  if (response.totalItems === 0) return null
  const row = response.items[0], id = planIdentity(row, draft.identity.kind)
  const expected = planIdentity(draft.identity, draft.identity.kind)
  if (!id || !expected || ['key', 'make', 'model', 'year'].some(key => id[key] !== expected[key]) ||
      !row.decision_snapshot_id || !row.model_git_sha || !(row.price_amount_eur > 0) || row.release_active !== true ||
      row.price_flag_anomaly !== false || ['gone', 'sold'].includes(row.source_flag) ||
      (timestamp(row.scraped_at) ?? Infinity) > now.getTime() ||
      !row.served_contract_version || !row.served_contract_sha ||
      savedPlanLiveUntil(row, id.kind) <= now.getTime()) throw new Error('Current listing did not match the saved identity or freshness')
  return row
}
